export const DEMAND_REFERENCE_ROUTE_SEGMENT = 'demands';

export const DEMAND_REFERENCE_ROUTE_PATH = '/demands';

export const DEMAND_REFERENCE_PARAM = 'reference';

export const DEMAND_REFERENCE_MISS_ROUTE_SEGMENT = 'not-found';

export const DEMAND_REFERENCE_MISS_ROUTE_PATH = '/demands/not-found';

export const MY_DEMANDS_ROUTE_PATH = '/my-demands';

export const MY_APPROVALS_ROUTE_PATH = '/my-approvals';
